jQuery( function( $ ) {

	const displayDigitalFormat = red61.display_presentation_format_for_digital;
	const displayInPersonFormat = red61.display_presentation_format_for_in_person;

	const performanceData = $( '#event-data' ).data( 'performances' );

	const disableTicketRequests = $( '#disable_ticket_requests' ).val();


	const performanceTemplate = _.template(
		'<li class=\'performance-time\' >' +
			'<button data-availability="<%- availability %>" data-id="<%- id %>" data-date="<%- performanceDate %>" data-reserved="<%- reserved %>" type="button" class="form-control time-select <%- cssClass %>" >' +
			'<span class="spinner-border spinner-border-sm" style="display: none" role="status" aria-hidden="true"></span>' +
				'<% if (performanceTime) { %>' +
					'<p><%- performanceTime %></p>' +
				'<% } %>' +		
				'<% if (performanceTime && translatedPresentationFormat) { %>' +
					'<br>' +
				'<% } %>' +		
				'<% if (translatedPresentationFormat) { %>' +
					'<p><%- translatedPresentationFormat %></p>' +
				'<% } %>' +
			'</button>' +
			'<% for ( vsepTag of vsepTags ) { %>' +
				'<p class="pre-performance-tags"><%- vsepTag.additionalInfo %></p>' +
			'<% } %>' +
		'</li>' );

	const digitalPerfTemplate = _.template(
		'<li class=\'performance-time digital-performance\'>' +
			'<button data-availability="<%- availability %>" data-id="<%- id %>" data-date="<%- performanceDate %>" data-reserved="<%- reserved %>" type="button" class="form-control time-select <%- cssClass %>" >' +
				'<span class="spinner-border spinner-border-sm" style="display: none" role="status" aria-hidden="true"></span>' +
				'<% if (title) { %>' +
					'<p><%- title %></p>' +
				'<% } %>' +			
				'<% if (title && translatedPresentationFormat) { %>' +
					'<br>' +
				'<% } %>' +	
				'<% if (translatedPresentationFormat) { %>' +
					'<p><%- translatedPresentationFormat %></p>' +
				'<% } %>' +			
			'</button>' +
			'<% for ( vsepTag of vsepTags ) { %>' +
				'<p class="pre-performance-tags"><%- vsepTag.additionalInfo %></p>' +
			'<% } %>' +
		'</li>' );

	const eventTicketTemplate = _.template(
		'<div class="media">' +
			'<div class="ticket-delever media-body">' +
				'<h3><%- title %></h3>' +
				'<p>Max <%- max %> ticket/s per person.</p>' +
			'</div>' +
			'<div class="card-number d-block">' +
				'<% if (remainingConcessionTickets > 0) { %>' +
					'<input type="number" min="0" data-testid="input-ticket-request-number" onkeyup=enforceMinMax(this) max="<%- max %>" name="qty[<%- priceId %>]" class="form-control qty" value="<%- qty %>">' +
				'<% } else { %>' +
					'<div>Unavailable</div>' +
				'<% } %>' +
			'</div>' +
		'</div>' );


	$.fn.datepicker.dates.en.daysMin = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

	function areThereConcTicksLeftFunc( performances ) {
		let areThereAnyConcessionsLeft = false;
		for ( let index = 0; index < performances.length; index++ ) {
			performances[index].remainingConcessionTicketsArray.forEach( remainingConcessionTickets => {
				if( 0 < remainingConcessionTickets ){
					areThereAnyConcessionsLeft = true;
					return;
				}
			} );
		}
		return areThereAnyConcessionsLeft;
	}

	function doConcessionCodesMatchFunc( performances ) {
		let doConcessionCodesMatch = false;
		for ( let index = 0; index < performances.length; index++ ) {
			performances[index].concessionCodeInCoreMatchesCustomizerCodeArray.forEach( doesConcessionCodesMatch => {
				if( doesConcessionCodesMatch ){
					doConcessionCodesMatch = true;
					return;
				}
			} );
		}
		return doConcessionCodesMatch;
	}

	if ( performanceData ) {

		if ( 0 < performanceData.digitalOnDemandPerfData.length ) {
			performanceData.digitalOnDemandPerfData.forEach( ( performanceData ) => {
				const presentationFormat = performanceData['presentationFormat'];
				performanceData['translatedPresentationFormat'] = null;
				if ( isPersentationFormatTypePopulated( presentationFormat ) ) {
					if ( ( isPresentationFormatTypeDigital( presentationFormat ) && displayDigitalFormat ) || ( !isPresentationFormatTypeDigital( presentationFormat ) && displayInPersonFormat ) ) {
						const translatedPresentationFormat = translatePresentationFormatFromType( presentationFormat );
						performanceData['translatedPresentationFormat'] = translatedPresentationFormat;
					}
				}

				$( '.performance-select' )
					.append( digitalPerfTemplate( performanceData ) );
			} );

			// If there are digital perfs then we want to show them without the user selecting a calender date
			$( '.ticket-head' ).attr( 'aria-expanded', 'true' );
			$( '#performance' ).addClass( 'show' );


			if ( 0 === performanceData.times[''].length ) {
				// If there are only digital performances

				// Mark the calender part as ticked straight away
				$( '[data-target="#calendar"]' ).attr( 'aria-completed', 'true' );

				// Do no show the message 'Select a date to show performances'
				$( '.no-perf' ).css( 'display', 'none' );
			}
		}

		if ( 0 < performanceData.dates.length ) {
			const splitFirstDate = performanceData.dates[0].split( '/' );
			// If this fires then the calender must need to be displayed
			const [hours, minutes] = disableTicketRequests.split( ':' );

			const currentDate = moment(); // Current date and time
			const disabledDateToCheck = moment( currentDate.add( hours, 'hours' ).add( minutes, 'minutes' ) );

			const perfStartingSoonFunc = ( performance ) => {
				if ( performance.performanceDate ) {
					const perfDate = moment( performance.performanceDate, 'Do MMMM YYYY HH:mm' );
					const perfDateFormatted = moment( perfDate ).format();
					return disabledDateToCheck.isAfter( perfDateFormatted );
				} else {
					return false;
				}
			};

			$( '.select-date-wrapper' ).css( 'display', 'block' );

			$( '.calendar-bootstrap' ).datepicker( {
				inline: true,
				multidate: false,
				startDate: performanceData.dates[0],
				endDate: performanceData.dates[performanceData.dates.length - 1],
				format: 'dd/mm/yyyy',
				maxViewMode: 1,
				weekStart: 1,
				defaultViewDate: {
					year: splitFirstDate[2],
					month: parseInt( splitFirstDate[1] ) - 1,
				},
				beforeShowDay: function( date ) {

					const momentDate = moment( date );
					const actualDate = momentDate.format( 'DD/MM/YYYY' );
					if ( performanceData.times[actualDate] ) {

						// Firstly checking if there are concessions pricebands
						const isThereAConcessionPricebandFunc = ( performance ) => true ==
							performance.isThereAConcessionPriceband;
						const isThereAConcessionPriceband = performanceData.times[actualDate].some(
							isThereAConcessionPricebandFunc );

						// Ensuring there is a concession code on at least 1 priceband which matches the code for this particular TR site
						// Will return true if 1 code matches one in the customizer
						const doConcessionCodesMatch = doConcessionCodesMatchFunc( performanceData.times[actualDate] );

						// Ensuring there are tickets left on at least 1 priceband so that it can display as available on the calender date
						// Will return true if there are

						const areThereConcTicketsLeft = areThereConcTicksLeftFunc( performanceData.times[actualDate] );

						const isPerfSoldOutFunc = ( performance ) => 0 === performance.availability;
						const isPerfSoldOut =  performanceData.times[actualDate].every(
							isPerfSoldOutFunc );

						const perfStartingSoon = performanceData.times[actualDate].every( perfStartingSoonFunc );

						// Even if the concession codes do not match we still want to display to the user that the performance is there.
						if ( isThereAConcessionPriceband && !areThereConcTicketsLeft && !isPerfSoldOut || isThereAConcessionPriceband && !doConcessionCodesMatch && !isPerfSoldOut ) {
							return {
								tooltip: 'No more comps available',
								enabled: false,
								classes: 'comps-exhausted',
							};
						}

						if ( areThereConcTicketsLeft && !isPerfSoldOut  && !perfStartingSoon ) {
							return {
								tooltip: 'performances available',
								enabled: true,
								classes: 'available',
							};
						}

						if ( isPerfSoldOut ) {
							return {
								enabled: false,
								tooltip: 'performances sold out',
								classes: 'sold-out',
							};
						}

						let disableDisplay = `within ${  parseInt( hours )  } hrs`;
						if( 0 >= hours ) {
							disableDisplay = `within ${  parseInt( minutes )  } mins`;
						} else if( 0 < minutes ) {
							disableDisplay += ` & ${  parseInt( minutes )  } mins`;
						}
						return {
							tooltip: `There are no tickets available to request as this show is starting ${disableDisplay}. You can buy tickets or get in touch with the venue directly to request a ticket`,
							enabled: false,
							classes: 'starting-soon',
						};
					}
					else {
						return {
							tooltip: 'no performances today',
							enabled: false,
						};
					}
				},
			} ).on( 'changeDate', ( event ) => {
				// set the checkmarks.
				$( '[data-target="#calendar"]' ).attr( 'aria-completed', 'true' );
				$( '[data-target="#performance"]' ).removeAttr( 'aria-completed' );
				$( '[data-target="#ticket"]' ).removeAttr( 'aria-completed' );

				// reset ticket data
				$( '#ticket .card-body' ).html( '' );
				$( '#ticket .no-results' ).show();
				$( '#ticket .no-results' )
					.text( 'You have to choose a performance to choose tickets.' );

				$( '.tickets-btn' ).addClass( 'd-none' );
				const selectedDate = moment( event.date ).format( 'DD/MM/YYYY' );
				if ( !$( '#performance' ).hasClass( 'show' ) ) {
					$( '[data-target="#performance"]' ).click();
				}

				$( '.performance-select' ).html( '' );

				const performanceTimes = performanceData.times[selectedDate];

				performanceTimes.forEach( ( performanceData ) => {
					const presentationFormat = performanceData['presentationFormat'];
					performanceData['translatedPresentationFormat'] = null;

					if ( isPersentationFormatTypePopulated( presentationFormat ) ) {
						if ( ( isPresentationFormatTypeDigital( presentationFormat ) && displayDigitalFormat ) || ( !isPresentationFormatTypeDigital( presentationFormat ) && displayInPersonFormat ) ) {
							const translatedPresentationFormat = translatePresentationFormatFromType( presentationFormat );
							performanceData['translatedPresentationFormat'] = translatedPresentationFormat;
						}
					}

					const areThereConcTicksLeftFuncOnPriceBand = ( element ) => 0 < element;
					const areThereConcTicksLeftFuncOnPriceBandResult = performanceData.remainingConcessionTicketsArray.some( areThereConcTicksLeftFuncOnPriceBand );

					const doConcessionCodesMatchFunc = ( element ) => true === element;
					const doConcessionCodesMatch = performanceData.concessionCodeInCoreMatchesCustomizerCodeArray.some( doConcessionCodesMatchFunc );

					const perfStartingSoon = perfStartingSoonFunc( performanceData );

					if ( 0 === performanceData.availability ) {
						performanceData.cssClass = 'sold-bg disable-clicking';
					}

					if ( !areThereConcTicksLeftFuncOnPriceBandResult && 0 < performanceData.availability || !doConcessionCodesMatch && 0 < performanceData.availability ) {
						performanceData.cssClass = 'comps-exhausted disable-clicking';
					}

					if( perfStartingSoon ) {
						performanceData.cssClass = 'starting-soon disable-clicking';
					}


					$( '.performance-select' )
						.append( performanceTemplate( performanceData ) );
				} );

				// This must be here to re-render the digital perfs when user clicks on calender date
				if ( 0 < performanceData.digitalOnDemandPerfData.length ) {
					performanceData.digitalOnDemandPerfData.forEach( ( performanceData ) => {
						$( '.performance-select' )
							.append( digitalPerfTemplate( performanceData ) );
					} );
				}
				// autoclick the first perfomance if it's the only one.
				if ( 1 === performanceTimes.length ) {
					$( '.performance-select button:first' ).click();
				}
				setDisabledStatusOnSubmit();
			} );
		}
	}


	function isPersentationFormatTypePopulated( presentationFormatType ) {
		let result = false;
		if ( 'PHYSICAL' == presentationFormatType || 'DIGITAL_LIVE' == presentationFormatType || 'DIGITAL_CATCHUP' == presentationFormatType || 'DIGITAL_OD' == presentationFormatType ) {
			result = true;
		}
		return result;
	}

	/**
	 * Checks that if the presentation format has been populated, it is digital in nature.
	 *
	 * @param {*} presentationFormatType
	 */
	function isPresentationFormatTypeDigital( presentationFormatType ) {
		let result = false;
		if ( 'DIGITAL_LIVE' == presentationFormatType || 'DIGITAL_CATCHUP' == presentationFormatType || 'DIGITAL_OD' == presentationFormatType ) {
			result = true;
		}
		return result;
	}

	function translatePresentationFormatFromType( presentationFormatType ) {
		let translatedFormat = null;
		if ( 'PHYSICAL' == presentationFormatType ) {
			translatedFormat = 'In Person';
		} else if ( 'DIGITAL_LIVE' == presentationFormatType ) {
			translatedFormat = 'Digital - Live';
		} else if ( 'DIGITAL_CATCHUP' == presentationFormatType ) {
			translatedFormat =  'Digital - Live + Catch up';
		} else if ( 'DIGITAL_OD' == presentationFormatType ) {
			translatedFormat = 'Digital - On Demand';
		} else {
			translatedFormat =  presentationFormatType;
		}
		return translatedFormat;
	}

	function fetchTickets() {
		const data = {
			'action': 'get_perf_prices',
			'performanceId': $( '#performanceId' ).val(),
		};

		return $.post( red61.ajax_url, data ).then();
	}

	$( '.performance-select' ).on( 'click', 'button', async function() {
		$( '[data-target="#ticket"]' ).removeAttr( 'aria-completed' );
		$( '[data-target="#performance"]' ).attr( 'aria-completed', 'true' );
		const $this = $( this );
		$this.closest( 'ul' ).find( 'button' ).removeClass( 'selected' );
		$this.addClass( 'selected' );
		$( '#performanceId' ).val( $this.data( 'id' ) );
		$this.find( 'span' ).show();
		if ( !$( '#ticket' ).hasClass( 'show' ) ) {
			$( '[data-target="#ticket"]' ).click();
		}
		const tickets = await fetchTickets();
		$this.find( 'span' ).hide();
		$( '#ticket .card-body' ).html( '' );

		const ticket = ( element ) => 0 < element.remainingConcessionTickets;
		const areThereAnyConcessionsLeft = tickets.some( ticket );

		if ( tickets.length && areThereAnyConcessionsLeft ) {
			$( '#ticket .no-results' ).hide();
			const qty = 1 < tickets.length ? 0 : 1;
			tickets.forEach( ticket => {
				$( '#ticket .tickets' ).append( eventTicketTemplate( {...ticket, qty} ) );

			} );
			$( '[data-target="#ticket"]' ).attr( 'aria-completed', 'true' );
		}
		else {
			$( '#ticket .no-results' ).show();
			$( '#ticket .no-results' )
				.text( 'No tickets found for this performance' );
		}
		setDisabledStatusOnSubmit();
	} );

	function setDisabledStatusOnSubmit() {
		let isSubmitDisabled = false;
		$( '.ticket-head' ).each( function() {
			if ( 'true' !== $( this ).attr( 'aria-completed' ) ) {
				isSubmitDisabled = true;
				// If one of the fields is not completed then the btn must be disabled
			}
		} );
		if ( isSubmitDisabled ) {
			// Input disabled
			$( '.submit-request' ).prop( 'disabled', true );
		} else {
			// Enable input
			$( '.submit-request' ).prop( 'disabled', false );
		}
	}
} );
